import Placeholder from "components/Layout/Placeholder";
import { ExecutionStatus } from "config/ts-utils";
import { executionTypes } from "containers/ExecutionFilter/constants";
import { buildExecutionFilterPathForResource } from "containers/ExecutionFilter/filterStorage";
import { getSingleStatFetching } from "containers/Stats/Stats.selectors";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import "./PercentageChart.scss";

const PercentageChart = ({ config, resourceData, stats }) => {
    const history = useHistory();
    const statDataFetching = useSelector(getSingleStatFetching);

    if (statDataFetching?.includes(config?.selector)) {
        return <Placeholder.Widget size={230} />;
    }

    const openExecutionMonitor = (e, status) => {
        e.stopPropagation();
        const filter = [
            {
                field: "status",
                op: "in",
                value: status,
            },
            {
                field: "execution_type",
                op: "in",
                value: executionTypes,
            },
        ];

        history.push(
            buildExecutionFilterPathForResource(resourceData, {
                filter: JSON.stringify({ and: filter }),
            })
        );
    };
    const successExecutionsPercentage = config?.dto({ resourceData, stats });

    return (
        <div className="percentage-chart flex flex-column flex-1">
            <div className="percentage-chart__numeric mt-auto">
                <span
                    className={`text-bold ${
                        successExecutionsPercentage > 50 ? "text-2xl" : "text-lg"
                    }`}
                >
                    {successExecutionsPercentage || 0}%
                </span>

                {successExecutionsPercentage != null && (
                    <span
                        className={`text-bold ${
                            successExecutionsPercentage - 50 > 50 ? "text-2xl" : "text-lg"
                        }`}
                    >
                        {100 - successExecutionsPercentage}%
                    </span>
                )}
            </div>
            <div
                className={`percentage-chart__bar${
                    successExecutionsPercentage == null ? " percentage-chart__bar--empty" : ""
                } mb-auto`}
                onClick={(e) =>
                    openExecutionMonitor(e, [
                        ExecutionStatus.ENDED_ERROR,
                        ExecutionStatus.ENDED_CANCELLED,
                    ])
                }
            >
                <div
                    style={{ width: `${successExecutionsPercentage || 0}%` }}
                    onClick={(e) => openExecutionMonitor(e, [ExecutionStatus.ENDED_SUCCESS])} // todo: change to Execution_Status in develop branch everywhere
                />
            </div>
            <div className="percentage-chart__legend flex justify-between mt-auto">
                <p className="text-sm text-bold">Successful</p>
                <p className="text-sm text-bold">Error</p>
            </div>
        </div>
    );
};

PercentageChart.defaultProps = {
    resourceData: {},
    stats: {},
};

PercentageChart.propTypes = {
    config: PropTypes.oneOfType([PropTypes.object]).isRequired,
    resourceData: PropTypes.oneOfType([PropTypes.object]),
    stats: PropTypes.oneOfType([PropTypes.object]),
};

export default PercentageChart;
